import { IAjaxConfig } from '../helpers';

export class EnumApiCert {
  /**
   * @dec 上传图片
   */
  readonly cert_feekback_save: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/feedback/ext/save',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 获取证书列表 产品资质
   */
  readonly cert_list: IAjaxConfig = {
    // url: '/api/gateway/product-sub-resource/portal/cert/ext/query',
    url: '/api/gateway/product-sub-resource/portal/cert/ext/query',
    awaitAuthenticated: false,
    // cache: true
  };

  /**
   * @dec 获取证书类型
   */
  readonly cert_type: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/constant/cert-type/query',
    awaitAuthenticated: false,
    cache: true,
  };

  /**
   * @dec 预览获取证书下拉
   */
  readonly cert_select_list: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/file/ext/info/{certId}/get',
    awaitAuthenticated: false,
    // cache: true
  };

  /**
   * @dec 预览文件地址
   */
  readonly cert_file_url: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/file/ext/signed-url/generate',
    awaitAuthenticated: false,
    cache: true,
    fos: true,
  };

  /**
   * @dec 证书产品类型
   */
  readonly cert_product_type: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/constant/product-type/query',
    method: 'get',
    awaitAuthenticated: false,
    cache: true,
  };

  /**
   * @dec 个人中心获取证书列表 //
   */
  readonly cert_down_list: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/down/record/ext/query',
  };

  /**
   * @dec 证书下载发送邮箱
   */
  readonly cert_send_email: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/email/send',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 获取剩余预览次数
   */
  readonly cert_preview_times: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/file/preview/count/get',
  };

  /**
   * @dec 证书下载
   */
  readonly cert_download: IAjaxConfig = {
    url: '/api/gateway/product-sub-resource/portal/cert/down',
    responseType: 'blob',
  };
}
